<template>
  <div class="login">
    <b-container>
      <h2 class="section-heading">Register</h2>
      <b-row>
        <b-col>
          <div class="login-card">
            <b-form v-if="!regSuccess">
              <!-- Firstname -->
              <b-form-group
                label="First Name"
              >
                <b-form-input
                  :class="{
                    'is-valid': !$v.user.firstname.$error && user.firstname,
                    'is-invalid': $v.user.firstname.$error && $v.user.firstname.$dirty
                  }"
                  v-model="$v.user.firstname.$model"
                ></b-form-input>
              </b-form-group>
              <!-- Last Name -->
              <b-form-group
                label="Last Name"
              >
                <b-form-input
                  :class="{
                    'is-valid': !$v.user.surname.$error && user.surname,
                    'is-invalid': $v.user.surname.$error && $v.user.surname.$dirty
                  }"
                  v-model="$v.user.surname.$model"
                ></b-form-input>
              </b-form-group>
              <!-- Title -->
              <b-form-group
                label="Title"  
              >
                <b-form-select
                  :class="{
                    'is-valid': !$v.user.title.$error && user.title,
                    'is-invalid': $v.user.title.$error && $v.user.title.$dirty
                  }"
                  v-model="$v.user.title.$model"
                  :options="titleOpts"
                ></b-form-select>
              </b-form-group>
              <!-- Email -->
              <b-form-group
                label="Email"
              >
                <b-form-input
                  :class="{
                    'is-valid': !$v.user.email.$error && user.email,
                    'is-invalid': $v.user.email.$error && $v.user.email.$dirty
                  }"
                  v-model="$v.user.email.$model"
                  type="email"
                ></b-form-input>
              </b-form-group>
              <!-- Phone -->
              <b-form-group
              class="d-flex align-items-center nonuk-check"
                label=""
              >
                <b-form-checkbox
                class="custom-checkbox"
                inline
                size="lg"
                  v-model="isNonUKIE"
                ><p class="checkbox-label">Is your phone a non UK or Ireland number</p></b-form-checkbox>
              </b-form-group>
              <b-form-group
                v-if="!isNonUKIE"
                label="Mobile"
              >
                <b-form-input
                  :class="{
                    'is-valid': !$v.user.phoneMob.$error && user.phoneMob,
                    'is-invalid': $v.user.phoneMob.$error && $v.user.phoneMob.$dirty
                  }"
                  v-model="$v.user.phoneMob.$model"
                  type="number"
                ></b-form-input>
              </b-form-group>
              <div v-if="isNonUKIE">
                <div class="mobile-container">
                  <b-form-group
                class="country-code"
                label="Code"
              >
                <b-form-input
                  :class="{
                    'is-valid': !$v.user.countryCode.$error && user.countryCode,
                    'is-invalid': $v.user.countryCode.$error && $v.user.countryCode.$dirty
                  }"
                  v-model="$v.user.countryCode.$model"
                  type="number"
                ></b-form-input>
              </b-form-group>
              <b-form-group
              class="mobile-number"
                label="Mobile"
              >
                <b-form-input
                  :class="{
                    'is-valid': !$v.user.phoneMob.$error && user.phoneMob,
                    'is-invalid': $v.user.phoneMob.$error && $v.user.phoneMob.$dirty
                  }"
                  v-model="$v.user.phoneMob.$model"
                  type="number"
                ></b-form-input>
              </b-form-group>
                </div>
              </div>
              <b-form-group
                class="d-flex align-items-center"
              >
                <b-form-checkbox
                class="custom-checkbox"
                  v-model="user.sendViaEmail"
                  size="lg"
                ><p class="checkbox-label">Check to also Send code via email</p></b-form-checkbox>
              </b-form-group>
              <p>v3</p>
              <b-form-group>
                <BtnMain @btnClicked="handleRegister"
                  text="Register"
                  btnClass="register-btn"
                  variant="warning"
                />
              </b-form-group>
            </b-form>
            
            <b-form-group>
              <b-alert v-if="regSuccess || regError"
                show
                :variant="regSuccess ? 'success' : 'danger'"
              >
                <p>{{ regMsg }}</p>
              </b-alert>
            </b-form-group>
            <div>
              <p>To return to the login page<a href="javascript:;" @click="$router.push('login')" target="_self"> click here</a></p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { registerUser } from '../services/api'
import BtnMain from '../components/BtnMain'
import { required, email, maxLength } from 'vuelidate/lib/validators'
export default {
  components: {
    BtnMain
  },
  data () {
    return {
      titleOpts: [{ text: 'Please select', value: null }, 'Mr', 'Mrs', 'Miss', 'Ms', 'Dr', 'Other'],
      user: {
        firstname: '',
        surname: '',
        title: '',
        email: '',
        phoneMob: '',
        countryCode: '',
        sendViaEmail: false,
      },
      isNonUKIE: false,
      regSuccess: false,
      regError: false,
      regMsg: ''
    }
  },
  methods: {
    async handleRegister () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        try {
          const res = await registerUser(this.user)
          if (res && res.data) {
            this.regError = false
            this.regSuccess = true
            window.scroll({
              top: 0
            })
            this.regMsg = 'Thank you, we have sent a link to your email. Please click the link to finish the registration process.'
          } else {
            this.regSuccess = false
            this.regError = true
            this.regMsg = 'There was an error with your registration, please check you have not already registered or try again later'
            setTimeout(() => {
              this.regError = false
              this.regSuccess = false
              this.regMsg = ''
            }, 5000)
          }
        } catch {
          this.regSuccess = false
          this.regError = true
          this.regMsg = 'There was an error with your registration, please check you have not already registered or try again later'
          setTimeout(() => {
            this.regError = false
            this.regSuccess = false
            this.regMsg = ''
          }, 5000)
        }
      } else {
        this.regSuccess = false
        this.regError = true
        this.regMsg = 'Please ensure all required fields are complete'
        setTimeout(() => {
          this.regError = false
          this.regSuccess = false
          this.regMsg = ''
        }, 5000)
      }
    }
  },
  validations() {
    if (this.isNonUKIE) {
      return {
        user: {
      firstname: {
        required: required
      },
      surname: {
        required: required
      },
      title: {
        required: required
      },
      email: {
        required: required,
        email: email
      },
      phoneMob: {
        required: required,
      },
      countryCode: {
        required: required,
        maxLength: maxLength(3)
      }
    }
      }
    } else {
      return {
        user: {
      firstname: {
        required: required
      },
      surname: {
        required: required
      },
      title: {
        required: required
      },
      email: {
        required: required,
        email: email
      },
      phoneMob: {
        required: required,
      },
    }
      }
    }
  }
}
</script>

<style scoped>
.checkbox-label {
  font-size: 16px !important;
  margin: 0;
  align-self: center;
  position: relative;
  top: 8px !important;
  font-weight: bolder;
}
.custom-checkbox {
  display: flex;
  align-items: center;

}

.nonuk-check {
  margin: 40px 0;
}

.mobile-container {
display: flex !important;
}

.country-code {
  width: 120px !important;
  margin-right: 20px !important;
}

.mobile-number {
  width: 100% !important;
}

</style>